import Vue from 'vue'
import VueRouter from 'vue-router'

const home = resolve => require(['page/home'], resolve)
const search = resolve => require(['page/search'], resolve)
// const join = resolve => require(['page/join'], resolve)
const member = resolve => require(['page/member'], resolve)
const about = resolve => require(['page/about'], resolve)
const productList = resolve => require(['page/productList'], resolve)
const productDetail = resolve => require(['page/productDetail'], resolve)
// const mobileDetail = resolve => require(['page/mobileDetail'], resolve)//扫码商详页、更改为手机版商详页
const useTerms = resolve => require(['page/useTerms'], resolve)
const infoDisclosure = resolve => require(['page/infoDisclosure'], resolve)
const mInfoDisclosurePhone = resolve => require(['page/mobile/infoDisclosurePhone'], resolve)
const mhome = resolve => require(['page/mobile/home'], resolve)
const mMember = resolve => require(['page/mobile/member'], resolve)
const mAbout = resolve => require(['page/mobile/about'], resolve)
const mProductList = resolve => require(['page/mobile/productList'], resolve)
const mProductDetail = resolve => require(['page/mobile/productDetail'], resolve)
const mSearch = resolve => require(['page/mobile/search'], resolve)
const mUseTerms = resolve => require(['page/mobile/useTerms'], resolve)
const fakeReportMiniAPP = resolve => require(['page/mobile/fakeReportMiniAPP'], resolve)
const checkInstructions = resolve => require(['page/checkInstructions'], resolve)
const activityDetail = resolve => require(['page/activityDetail'], resolve)
const mActivityDetail = resolve => require(['page/mobile/activityDetail'], resolve)
const merchantsJoin = resolve => require(['page/merchantsJoin'], resolve)
const mMerchantsJoin = resolve => require(['page/mobile/merchantsJoin'], resolve)
const downloadPagehsy = resolve => require(['page/downloadPagehsy'], resolve)
const downloadPagehgl = resolve => require(['page/downloadPagehgl'], resolve)
const fakeReportPage = resolve => require(['page/fakeReportPage'], resolve)
const aliPay = resolve => require(['page/mobile/aliPay'], resolve)
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: { pageName: '官网首页' }
  },
  {
    path: '/search',
    name: 'search',
    component: search,
    meta: {
      keepAlive: true,
      pageName: '搜索页'
    }
  },
  // {
  //   path: '/join',
  //   name: 'join',
  //   component: join
  // },
  {
    path: '/member',
    name: 'member',
    component: member,
    meta: { pageName: '成为会员页面' }
  },
  {
    path: '/about/:id',
    name: 'about',
    component: about,
    meta: { pageName: '关于特百惠' }
  },
  {
    path: '/productList',
    name: 'productList',
    component: productList,
    meta: {
      keepAlive: true,
      pageName: '产品列表页'
    }
  },
  {
    path: '/productDetail/:id',
    name: 'productDetail',
    component: productDetail,
    meta: { pageName: '产品详情页' }
  },
  {
    path: '/useTerms',
    name: 'useTerms',
    component: useTerms,
    meta: { pageName: '使用条款' }
  },
  {
    path: '/infoDisclosure',
    name: 'infoDisclosure',
    component: infoDisclosure,
    meta: { pageName: '信息披露' }
  },
  {
    path: '/activityDetail/:id',
    name: 'activityDetail',
    component: activityDetail
  },
  {
    path: '/merchantsJoin',
    name: 'merchantsJoin',
    component: merchantsJoin,
    meta: { pageName: '招商加盟页面' }
  },
  {
    path: '/mobileDetail/:id',
    name: 'mobileDetail',
    component: mProductDetail,
    meta: {
      pageName: '产品详情页'
    }
  },
  {
    path: '/mobile/home',
    name: 'mobileHome',
    component: mhome,
    meta: { pageName: '官网首页' }
  },
  {
    path: '/mobile/member',
    name: 'mobileMember',
    component: mMember,
    meta: { pageName: '成为会员页面' }
  },
  {
    path: '/mobile/about/:id',
    name: 'mobileAbout',
    component: mAbout,
    meta: { pageName: '关于特百惠' }
  },
  {
    path: '/mobile/productList',
    name: 'mobileProductList',
    component: mProductList,
    meta: {
      keepAlive: true,
      pageName: '产品列表页'
    }
  },
  {
    path: '/mobile/productDetail/:id',
    name: 'mobileProductDetail',
    component: mProductDetail,
    meta: {
      pageName: '产品详情页'
    }
  },
  {
    path: '/mobile/search',
    name: 'mobileSearch',
    component: mSearch,
    meta: {
      keepAlive: true,
      pageName: '搜索页'
    }
  },
  {
    path: '/mobile/infoDisclosurePhone',
    name: 'mobileInfoDisclosurePhone',
    component: mInfoDisclosurePhone,
    meta: {
      pageName: '信息披露'
    }
  },
  {
    path: '/mobile/useTerms',
    name: 'mobileUseTerms',
    component: mUseTerms,
    meta: {
      pageName: '使用条款'
    }
  },
  {
    path: '/mobile/activityDetail/:id',
    name: 'mobileActivityDetail',
    component: mActivityDetail
  },
  {
    path: '/mobile/merchantsJoin',
    name: 'mobileMerchantsJoin',
    component: mMerchantsJoin,
    meta: { pageName: '招商加盟页面' }
  },
  {
    path: '/mobile/aliPay',
    name: 'aliPay',
    component: aliPay,
    meta: { pageName: '工行聚合支付', noHeader: false }
  },
  {
    path: '/checkInstructions',
    name: 'checkInstructions',
    component: checkInstructions,
    meta: {
      noHeader: true
    }
  },
  {
    path: '/downloadPagehsy',
    name: 'downloadPagehsy',
    component: downloadPagehsy,
    meta: { pageName: '下载会生意', noHeader: true }
  },
  {
    path: '/downloadPagehgl',
    name: 'downloadPagehgl',
    component: downloadPagehgl,
    meta: { pageName: '下载慧管理', noHeader: true }
  },
  {
    path: '/fakeReportPage',
    name: 'fakeReportPage',
    component: fakeReportPage,
    meta: { pageName: '举报假货', noHeader: true }//员工版：慧管理使用
  },
  {
    path: '/mobile/fakeReportMiniAPP',
    name: 'fakeReportMiniAPP',
    component: fakeReportMiniAPP,
    meta: { pageName: '举报假货', noHeader: true }//会员版：小程序使用
  }
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }

})

// 关于特百惠路由名称数组
const aboutRoute = {
  '3': '关于特百惠-公司简介',
  '4': '关于特百惠-荣誉殿堂',
  '5': '关于特百惠-优质产品',
  '11': '关于特百惠-防伪查询',
  '12': '关于特百惠-举报假货',
}

router.beforeEach((to, from, next) => { // router之前预处理
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.name === "about") {
    to.meta.pageName = aboutRoute[to.params.id]
  }
  // let sourceName=sessionStorage.getItem("sourceName")
  // if(sourceName === "miniAPP"){
  //   to.meta.noHeader=true
  // }
  //console.log(to,from,'beforeEach');
  // window.scrollTo(0, 0)
  next()
  // pv埋点
  // const {
  //   aplus_queue
  // } = window;
  // const channelCode = to.query.channelCode || localStorage.getItem('pbmChannelCode') || to.query.channalCode || '';
  // const userId = localStorage.getItem('userId') || '';
  // if (!userId || !channelCode) return
  // aplus_queue.push({
  //   action: 'aplus.sendPV',
  //   arguments: [{
  //     is_auto: false
  //   }, {
  //     page_path: to.path,
  //     channelCode,
  //     userId
  //   }]
  // });
  // aplus_queue.push({
  //   action: 'aplus.record',
  //   arguments: [enterPage_custom, 'CLK', {
  //     page_path: to.path,
  //     channelCode,
  //     userId
  //   }]
  // });
})
router.afterEach((to, from, next) => { // router之后预处理
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  // window.scrollTo(0, 0)
  console.log(to, from, 'afterEach');
  let tmpB = (from.name === 'aliPay' && to.name !== 'aliPay')
  //console.log(`=====================666=====================${tmpB}`)
  if (tmpB) {//强制重载
    location.reload(true)
  } else {
    next()
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js